import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './faq-search.magic.css.js';
import script from './faq-search.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",attrs:{"part":"wrapper","data-v-test-id":"faq-search"}},[(_vm.isLoading)?_c('magic-ui-loader',{staticClass:"loader",attrs:{"part":"loader"}}):[_c('magic-ui-link',{attrs:{"to":_vm.RoutablePage.FAQ}},[_c('magic-ui-icon',{staticClass:"icon",attrs:{"name":"left-arrow-long","part":"icon"}})],1),_vm._v(" "),_vm._l((_vm.searchResults),function(entry){return _c('magic-faq-entry',{key:entry.id,staticClass:"faq-entry",attrs:{"part":"faq-entry","data-v-test-id":"faq-search-entry","question":entry.question,"answer":entry.answer}})}),_vm._v(" "),(!_vm.hasSearchResults)?_c('div',{staticClass:"empty",attrs:{"part":"empty"}},[_c('magic-ui-text',{staticClass:"title",attrs:{"tag":"h3","part":"title","content":_vm.$t('faq.search.empty-title')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"text",attrs:{"tag":"p","part":"text","content":_vm.$t('faq.search.empty-text')}})],1):_vm._e()]],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-fd7c4812_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-fd7c4812";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
